(function () {
  var STORAGE_PREFIX = 'pdp_selected_diamond_';
  var stateByRoot = new WeakMap();

  function qs(root, sel) {
    return root ? root.querySelector(sel) : null;
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function stripTrailingSlash(url) {
    return String(url || '').replace(/\/+$/, '');
  }

  function resolveSameOriginProxyPath(url, fallbackPath) {
    var configured = stripTrailingSlash(url || '');
    if (!configured) return fallbackPath;
    if (configured.charAt(0) === '/') return configured;
    try {
      var parsed = new URL(configured);
      if (parsed.pathname && parsed.pathname.indexOf('/apps/nivoda') !== -1) {
        return stripTrailingSlash(parsed.pathname) || fallbackPath;
      }
    } catch (e) {}
    return configured;
  }

  function isDesignMode() {
    return !!(window.Shopify && window.Shopify.designMode);
  }

  function getRoot() {
    return document.querySelector('[data-product-diamond-options]');
  }

  function getState(root) {
    if (!root) return null;
    var state = stateByRoot.get(root);
    if (!state) {
      state = {
        items: [],
        selectedOfferId: '',
        requestId: 0,
        expanded: false,
        carat: Number(root.getAttribute('data-default-carat')) || 1,
        ringPriceCents: Number(root.getAttribute('data-fallback-price-cents')) || 0,
        variants: [],
      };
      stateByRoot.set(root, state);
    }
    return state;
  }

  function parseCaratLabel(label) {
    var match = String(label || '').match(/(\d+(?:\.\d+)?)/);
    if (!match) return null;
    var value = Number(match[1]);
    return isFinite(value) ? value : null;
  }

  function readSelectedCarat(root) {
    var defaultCarat = Number(root.getAttribute('data-default-carat')) || 1;
    var productInfo = root.closest('product-info') || document.querySelector('product-info');
    if (!productInfo) return defaultCarat;

    var fieldsets = productInfo.querySelectorAll('fieldset.product-form__input');
    for (var i = 0; i < fieldsets.length; i++) {
      var legend = fieldsets[i].querySelector('legend, .form__label, .product-form__option-title');
      var labelText = (legend && legend.textContent) || '';
      if (!/carat/i.test(labelText)) continue;

      var checked = fieldsets[i].querySelector('input[type="radio"]:checked');
      if (checked) {
        var fromInput = parseCaratLabel(checked.value) || parseCaratLabel(checked.getAttribute('data-value'));
        if (fromInput != null) return fromInput;
        var lab = fieldsets[i].querySelector('label[for="' + checked.id + '"]');
        var fromLabel = parseCaratLabel(lab && lab.textContent);
        if (fromLabel != null) return fromLabel;
      }
    }

    var selects = productInfo.querySelectorAll('select[name^="options"]');
    for (var s = 0; s < selects.length; s++) {
      var selectLabel = '';
      var labelEl = productInfo.querySelector('label[for="' + selects[s].id + '"]');
      if (labelEl) selectLabel = labelEl.textContent || '';
      if (!/carat/i.test(selectLabel) && !/carat/i.test(selects[s].name || '')) continue;
      var selected = selects[s].options[selects[s].selectedIndex];
      var parsed = parseCaratLabel(selected && selected.value) || parseCaratLabel(selected && selected.text);
      if (parsed != null) return parsed;
    }

    return defaultCarat;
  }

  function loadVariantPrices(root) {
    var state = getState(root);
    if (!state) return;
    var script = document.querySelector('[data-pdo-variant-prices]');
    if (!script) return;
    try {
      var parsed = JSON.parse(script.textContent || '[]');
      state.variants = Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      state.variants = [];
    }
  }

  function readRingPriceCents(root, carat) {
    var state = getState(root);
    if (!state) return 0;

    var productInfo = root.closest('product-info') || document.querySelector('product-info');
    var variantIdInput = productInfo && productInfo.querySelector('form[action*="/cart/add"] [name="id"], [name="id"]');
    var selectedVariantId = variantIdInput && variantIdInput.value ? String(variantIdInput.value) : '';

    if (selectedVariantId && state.variants.length) {
      for (var i = 0; i < state.variants.length; i++) {
        if (String(state.variants[i].id) === selectedVariantId) {
          return Number(state.variants[i].price) || 0;
        }
      }
    }

    if (state.variants.length && carat != null) {
      for (var v = 0; v < state.variants.length; v++) {
        var options = state.variants[v].options || [];
        for (var o = 0; o < options.length; o++) {
          var optionCarat = parseCaratLabel(options[o]);
          if (optionCarat != null && Math.abs(optionCarat - carat) < 0.001) {
            return Number(state.variants[v].price) || 0;
          }
        }
      }
    }

    if (state.ringPriceCents > 0) return state.ringPriceCents;
    return Number(root.getAttribute('data-fallback-price-cents')) || 0;
  }

  /**
   * Fixed carat + diamond-price bands by selected total carat weight variant.
   * Prices are AUD retail dollars for the diamond stone (not the ring).
   */
  var CARAT_TIERS = [
    { select: 1, caratMin: 1.0, caratMax: 1.1, priceMin: 0, priceMax: 550 },
    { select: 1.5, caratMin: 1.5, caratMax: 1.6, priceMin: 550, priceMax: 940 },
    { select: 2, caratMin: 2.0, caratMax: 2.1, priceMin: 940, priceMax: 1150 },
    { select: 2.5, caratMin: 2.5, caratMax: 2.6, priceMin: 1150, priceMax: 1300 },
    { select: 3, caratMin: 3.0, caratMax: 3.1, priceMin: 1300, priceMax: 1500 },
    { select: 3.5, caratMin: 3.5, caratMax: 3.6, priceMin: 1500, priceMax: 1650 },
    { select: 4, caratMin: 4.0, caratMax: 4.1, priceMin: 1650, priceMax: 1850 },
    { select: 4.5, caratMin: 4.5, caratMax: 4.6, priceMin: 1850, priceMax: 2000 },
    { select: 5, caratMin: 5.0, caratMax: 5.1, priceMin: 2000, priceMax: 2200 },
    { select: 5.5, caratMin: 5.5, caratMax: 5.6, priceMin: 2200, priceMax: 2250 },
    { select: 6, caratMin: 6.0, caratMax: 6.1, priceMin: 2250, priceMax: 2600 },
  ];

  function getCaratTier(selectedCarat) {
    var carat = Number(selectedCarat);
    if (!isFinite(carat) || carat <= 0) carat = 1;

    var best = CARAT_TIERS[0];
    var bestDelta = Math.abs(best.select - carat);
    for (var i = 1; i < CARAT_TIERS.length; i++) {
      var delta = Math.abs(CARAT_TIERS[i].select - carat);
      if (delta < bestDelta) {
        best = CARAT_TIERS[i];
        bestDelta = delta;
      }
    }
    return best;
  }

  function diamondRetailDollars(item) {
    if (!item) return NaN;
    var cents = Number(item.price);
    if (!isFinite(cents)) return NaN;
    // Nivoda prices are typically cents; treat unusually small values as dollars.
    if (cents > 0 && cents < 50) return cents;
    return cents / 100;
  }

  function diamondCarats(item) {
    var value = Number(item && item.carats);
    return isFinite(value) ? value : NaN;
  }

  function allowedClarities(root) {
    return String(root.getAttribute('data-clarities') || 'VVS2')
      .split(',')
      .map(function (part) {
        return part.trim().toUpperCase();
      })
      .filter(Boolean);
  }

  function getDisplayLimit(root) {
    var desktop = Number(root.getAttribute('data-limit-desktop')) || 5;
    var mobile = Number(root.getAttribute('data-limit-mobile')) || 4;
    return window.matchMedia('(min-width: 750px)').matches ? desktop : mobile;
  }

  function allowedColors(root) {
    return String(root.getAttribute('data-colors') || 'E,F')
      .split(',')
      .map(function (part) {
        return part.trim().toUpperCase();
      })
      .filter(Boolean);
  }

  function formatCaratChip(carat) {
    var value = Number(carat);
    if (!isFinite(value)) return '1 CT';
    if (Math.abs(value - Math.round(value)) < 0.001) return Math.round(value) + ' CT';
    return String(parseFloat(value.toFixed(2))) + ' CT';
  }

  function formatShapeLabel(shape) {
    if (!shape) return 'Diamond';
    return String(shape)
      .toLowerCase()
      .replace(/[_-]+/g, ' ')
      .replace(/\b\w/g, function (c) {
        return c.toUpperCase();
      })
      .trim();
  }

  function normalizeShapeForApi(shape) {
    var key = String(shape || '')
      .trim()
      .toUpperCase()
      .replace(/[\s-]+/g, '_');
    var aliases = {
      SQ_EMERALD: 'EMERALD',
      SQ_RADIANT: 'RADIANT',
      CUSHION_ALL: 'CUSHION',
      CUSHION_BRILLIANT: 'CUSHION',
      CUSHION_MODIFIED: 'CUSHION',
      SQUARE_CUSHION: 'CUSHION',
      SQUARE: 'PRINCESS',
    };
    if (aliases[key]) return aliases[key];
    if (key.indexOf('CUSHION') === 0 || key === 'SQUARE_CUSHION') {
      return 'CUSHION,CUSHION BRILLIANT,CUSHION MODIFIED,SQUARE CUSHION';
    }
    return key.split('_')[0] || '';
  }

  function getMediaUrl(item) {
    if (!item) return '';
    return (
      item.image ||
      item.imageUrl ||
      item.image_url ||
      item.thumbUrl ||
      item.thumbnail ||
      item.videoThumbnail ||
      ''
    );
  }

  function loadSampleDiamondImagesMap() {
    if (window.__pdoSampleDiamondImages) return window.__pdoSampleDiamondImages;
    var el = document.getElementById('pdo-sample-diamond-images');
    var map = {};
    if (el) {
      try {
        var raw = String(el.textContent || '').replace(/^\uFEFF/, '').trim();
        map = raw ? JSON.parse(raw) : {};
        if (!map || typeof map !== 'object') map = {};
      } catch (e) {
        map = {};
      }
    }
    window.__pdoSampleDiamondImages = map;
    return map;
  }

  function normalizeSampleShapeKey(shape) {
    return String(shape || '')
      .trim()
      .toUpperCase()
      .replace(/_/g, ' ')
      .replace(/\s+/g, ' ');
  }

  function absoluteMediaUrl(url) {
    var value = String(url || '').trim();
    if (!value) return '';
    if (value.indexOf('//') === 0) return 'https:' + value;
    return value;
  }

  function getSampleDiamondImageUrl(shape) {
    var map = loadSampleDiamondImagesMap();
    if (!map) return '';
    var key = normalizeSampleShapeKey(shape);
    if (!key) return '';
    if (map[key]) return absoluteMediaUrl(map[key]);

    var base = key.split(' ')[0];
    if (base && map[base]) return absoluteMediaUrl(map[base]);

    if (key.indexOf('CUSHION') === 0 && map.CUSHION) return absoluteMediaUrl(map.CUSHION);
    if (key.indexOf('RADIANT') === 0 && map.RADIANT) return absoluteMediaUrl(map.RADIANT);
    if ((key.indexOf('EMERALD') === 0 || key === 'SQ EMERALD') && map.EMERALD) {
      return absoluteMediaUrl(map.EMERALD);
    }
    return '';
  }

  function getCardMediaUrl(item) {
    var image = getMediaUrl(item);
    if (image) {
      return { url: absoluteMediaUrl(image), isSample: false };
    }
    var sampleUrl = getSampleDiamondImageUrl(item && item.shape);
    if (sampleUrl) {
      return { url: sampleUrl, isSample: true };
    }
    return { url: '', isSample: false };
  }

  function formatCaratDisplay(carats) {
    var value = Number(carats);
    if (!isFinite(value)) return '';
    return parseFloat(value.toFixed(2)) + ' ct';
  }

  function formatDiamondTitle(item) {
    var carat = formatCaratDisplay(item.carats);
    var shape = formatShapeLabel(item.shape);
    return [carat, shape].filter(Boolean).join(' ');
  }

  function formatDiamondSpecs(item) {
    return [item.color, item.clarity, item.lab].filter(Boolean).join(' · ');
  }

  function setStatus(root, message, isError) {
    var status = qs(root, '[data-pdo-status]');
    if (!status) return;
    status.hidden = !message;
    status.textContent = message || '';
    status.classList.toggle('is-error', !!isError);
  }

  function buildProxyUrl(root, tier) {
    var diamondsUrl = resolveSameOriginProxyPath(
      root.getAttribute('data-diamonds-url'),
      '/apps/nivoda/diamonds'
    );
    var limit = Number(root.getAttribute('data-limit')) || 5;
    var diamondType = root.getAttribute('data-diamond-type') || 'labgrown';
    var colors = root.getAttribute('data-colors') || 'E,F';
    var clarities = root.getAttribute('data-clarities') || 'VVS2';
    var shape = normalizeShapeForApi(root.getAttribute('data-shape'));

    var params = new URLSearchParams({
      offset: '0',
      limit: String(Math.max(limit * 6, 30)),
      labgrown: diamondType === 'natural' ? 'false' : 'true',
      diamond_type: diamondType === 'natural' ? 'natural' : 'labgrown',
      colour_mode: 'white',
      color: colors,
      clarity: clarities,
      carat_min: String(tier.caratMin),
      carat_max: String(tier.caratMax),
      sort: 'price_asc',
    });

    if (shape) params.set('shape', shape);
    // The $1–$550 style price pair is not the card price. The tier cap is
    // applied in filterByTier against retail dollars instead.

    return diamondsUrl + '?' + params.toString();
  }

  function buildDiamondLineProperties(diamond) {
    var cert = String(diamond.certNumber || diamond.offerId || '').trim();
    var lab = String(diamond.lab || 'IGI').toUpperCase();
    var stoneType =
      diamond.labgrown === true || diamond.labgrown === 'true'
        ? 'Lab Grown'
        : 'Natural';
    var carat = diamond.carats != null ? String(diamond.carats) : '';
    var shape = formatShapeLabel(diamond.shape);
    var color = diamond.color || '';
    var clarity = diamond.clarity || '';

    var summaryParts = [];
    if (carat) summaryParts.push(carat + 'ct');
    if (shape) summaryParts.push(shape);
    if (color) summaryParts.push(color);
    if (clarity) summaryParts.push(clarity);
    if (lab) summaryParts.push(lab);

    return {
      'Chosen Diamond': summaryParts.join(' · '),
      'Diamond Certificate': cert,
      // Hidden from cart UI (underscore) but kept for fulfilment / admin.
      _diamond_shape: shape,
      _diamond_carat: carat,
      _diamond_color: color,
      _diamond_clarity: clarity,
      _diamond_lab: lab,
      _diamond_type: stoneType,
      _diamond_stock: diamond.offerId || diamond.diamondId || '',
      _diamond_included_in_price: 'true',
    };
  }

  function getSelectedDiamond(root) {
    var state = getState(root);
    if (!state || !state.selectedOfferId) return null;
    for (var i = 0; i < state.items.length; i++) {
      if (String(state.items[i].offerId) === String(state.selectedOfferId)) {
        return state.items[i];
      }
    }
    return null;
  }

  function persistSelection(root, diamond) {
    try {
      var key = STORAGE_PREFIX + (root.getAttribute('data-product-id') || '');
      if (!diamond) {
        localStorage.removeItem(key);
        return;
      }
      localStorage.setItem(key, JSON.stringify(diamond));
    } catch (e) {}
  }

  function selectDiamond(root, offerId, options) {
    var state = getState(root);
    if (!state) return;
    var opts = options || {};
    var nextId = String(offerId || '');
    // Clicking the already-selected card clears selection (unless forced).
    if (!opts.force && nextId && nextId === String(state.selectedOfferId || '')) {
      nextId = '';
    }
    state.selectedOfferId = nextId;
    root.querySelectorAll('[data-pdo-card]').forEach(function (card) {
      var selected = card.getAttribute('data-offer-id') === state.selectedOfferId;
      card.classList.toggle('is-selected', selected);
      card.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });
    var diamond = getSelectedDiamond(root);
    persistSelection(root, diamond);
    var hint = qs(root, '[data-pdo-hint]');
    if (hint) {
      hint.textContent = diamond
        ? 'Included in your ring price — we’ll craft your order with the diamond you select.'
        : 'Optional - select a diamond to include with your ring (included in the ring price).';
    }
  }

  function clearDiamondSelection(root) {
    var state = getState(root);
    if (!state) return;
    state.selectedOfferId = '';
    root.querySelectorAll('[data-pdo-card]').forEach(function (card) {
      card.classList.remove('is-selected');
      card.setAttribute('aria-pressed', 'false');
    });
    persistSelection(root, null);
    var hint = qs(root, '[data-pdo-hint]');
    if (hint) {
      hint.textContent =
        'Optional - select a diamond to include with your ring (included in the ring price).';
    }
  }

  function formatDimensions(item) {
    if (!item) return '';
    if (item.measurements) return String(item.measurements);
    var length = item.length || item.Length;
    var width = item.width || item.Width;
    var depth = item.depth || item.Depth || item.height;
    if (length && width && depth) {
      return length + ' × ' + width + ' × ' + depth + ' mm';
    }
    if (length && width) return length + ' × ' + width + ' mm';
    return '';
  }

  function getVideoUrl(item) {
    if (!item) return '';
    return item.video || item.videoUrl || item.video_url || item.v360Url || item.v360 || '';
  }

  function getCertificateUrl(item) {
    if (!item) return '';
    return (
      item.certificateUrl ||
      item.certificate_url ||
      item.certUrl ||
      item.cert_url ||
      item.reportUrl ||
      ''
    );
  }

  function findDiamondByOfferId(root, offerId) {
    var state = getState(root);
    if (!state) return null;
    for (var i = 0; i < state.items.length; i++) {
      if (String(state.items[i].offerId) === String(offerId)) return state.items[i];
    }
    return null;
  }

  function getDetailModal(root) {
    var sectionId = root.getAttribute('data-section-id') || '';
    return (
      document.getElementById('PdoDetailModal-' + sectionId) ||
      document.querySelector('[data-pdo-detail-modal]')
    );
  }

  function ensureDetailModalOnBody(root) {
    var modal = getDetailModal(root);
    if (!modal || !document.body) return modal;
    if (modal.parentNode !== document.body) {
      document.body.appendChild(modal);
    }
    return modal;
  }

  function closeDetailModal(root) {
    var modal = ensureDetailModalOnBody(root);
    if (!modal) return;
    if (typeof modal.close === 'function' && modal.open) {
      modal.close();
    }
    modal._pdoActiveOfferId = '';
  }

  function buildSpecRows(item) {
    var stoneType =
      item.labgrown === true || item.labgrown === 'true' ? 'Lab Grown' : 'Natural';
    return [
      { label: 'Shape', value: formatShapeLabel(item.shape) },
      { label: 'Carat', value: formatCaratDisplay(item.carats) },
      { label: 'Color', value: item.color || '' },
      { label: 'Clarity', value: item.clarity || '' },
      { label: 'Cut', value: item.cut || '' },
      { label: 'Lab', value: item.lab || '' },
      { label: 'Certificate', value: item.certNumber || item.offerId || '' },
      { label: 'Type', value: stoneType },
      { label: 'Polish', value: item.polish || '' },
      { label: 'Symmetry', value: item.symmetry || '' },
      { label: 'Fluorescence', value: item.fluorescence || '' },
      { label: 'Dimensions', value: formatDimensions(item) },
    ].filter(function (row) {
      return row.value;
    });
  }

  function setDetailMedia(mediaEl, options) {
    if (!mediaEl) return;
    var opts = options || {};
    var type = opts.type || 'image';
    var url = opts.url || '';
    var title = opts.title || 'Diamond preview';
    var isSample = !!opts.isSample;

    mediaEl.classList.remove('is-video', 'is-image', 'is-empty');

    if (type === 'video' && url) {
      mediaEl.classList.add('is-video');
      if (/\.(mp4|webm|ogg)(\?|$)/i.test(url)) {
        mediaEl.innerHTML =
          '<video src="' +
          escapeHtml(url) +
          '" controls autoplay muted loop playsinline></video>';
      } else {
        mediaEl.innerHTML =
          '<iframe src="' +
          escapeHtml(url) +
          '" title="' +
          escapeHtml(title) +
          '" loading="lazy" allowfullscreen referrerpolicy="no-referrer"></iframe>';
      }
      return;
    }

    if (url) {
      mediaEl.classList.add('is-image');
      mediaEl.innerHTML =
        '<img src="' +
        escapeHtml(url) +
        '" alt="' +
        escapeHtml(title) +
        '"' +
        (isSample ? ' class="is-sample"' : '') +
        '>';
      return;
    }

    mediaEl.classList.add('is-empty');
    mediaEl.innerHTML =
      '<span class="pdo-detail-modal__media-fallback">' +
      escapeHtml(opts.fallback || 'Diamond') +
      '</span>';
  }

  function openDetailModal(root, offerId) {
    var modal = ensureDetailModalOnBody(root);
    var item = findDiamondByOfferId(root, offerId);
    if (!modal || !item) return;

    modal._pdoActiveOfferId = String(offerId);
    var title = formatDiamondTitle(item);
    var specs = formatDiamondSpecs(item);
    var media = getCardMediaUrl(item);
    var videoUrl = getVideoUrl(item);
    var certUrl = getCertificateUrl(item);
    var stoneType =
      item.labgrown === true || item.labgrown === 'true' ? 'Lab Grown Diamond' : 'Natural Diamond';

    var titleEl = modal.querySelector('[data-pdo-detail-title]');
    var summaryEl = modal.querySelector('[data-pdo-detail-summary]');
    var eyebrowEl = modal.querySelector('[data-pdo-detail-eyebrow]');
    var specsEl = modal.querySelector('[data-pdo-detail-specs]');
    var mediaEl = modal.querySelector('[data-pdo-detail-media]');
    var thumbsEl = modal.querySelector('[data-pdo-detail-thumbs]');
    var sampleEl = modal.querySelector('[data-pdo-detail-sample]');
    var certEl = modal.querySelector('[data-pdo-detail-cert]');
    var selectEl = modal.querySelector('[data-pdo-detail-select]');

    if (titleEl) titleEl.textContent = title;
    if (summaryEl) summaryEl.textContent = specs;
    if (eyebrowEl) eyebrowEl.textContent = stoneType;

    if (specsEl) {
      specsEl.innerHTML = buildSpecRows(item)
        .map(function (row) {
          return (
            '<div class="pdo-detail-modal__spec-row">' +
            '<dt>' +
            escapeHtml(row.label) +
            '</dt>' +
            '<dd>' +
            escapeHtml(row.value) +
            '</dd>' +
            '</div>'
          );
        })
        .join('');
    }

    // Prefer photo first — 360 iframes often crop poorly in a square frame.
    var initialType = media.url ? 'image' : videoUrl ? 'video' : 'empty';
    var initialUrl = initialType === 'image' ? media.url : videoUrl;
    setDetailMedia(mediaEl, {
      type: initialType,
      url: initialUrl,
      title: title,
      isSample: media.isSample && initialType === 'image',
      fallback: formatShapeLabel(item.shape),
    });

    if (sampleEl) sampleEl.hidden = !(media.isSample && initialType === 'image');

    if (thumbsEl) {
      var thumbs = [];
      if (media.url) {
        thumbs.push({ type: 'image', url: media.url, label: 'Photo', sample: media.isSample });
      }
      if (videoUrl) {
        thumbs.push({ type: 'video', url: videoUrl, label: '360°', sample: false });
      }
      if (thumbs.length > 1) {
        thumbsEl.hidden = false;
        thumbsEl.innerHTML = thumbs
          .map(function (thumb, index) {
            return (
              '<button type="button" class="pdo-detail-modal__thumb' +
              (index === 0 ? ' is-active' : '') +
              '" data-pdo-thumb-type="' +
              escapeHtml(thumb.type) +
              '" data-pdo-thumb-url="' +
              escapeHtml(thumb.url) +
              '" data-pdo-thumb-sample="' +
              (thumb.sample ? 'true' : 'false') +
              '">' +
              escapeHtml(thumb.label) +
              '</button>'
            );
          })
          .join('');
      } else {
        thumbsEl.hidden = true;
        thumbsEl.innerHTML = '';
      }
    }

    if (certEl) {
      if (certUrl) {
        certEl.hidden = false;
        certEl.href = certUrl;
      } else {
        certEl.hidden = true;
        certEl.removeAttribute('href');
      }
    }

    modal._pdoActiveOfferId = String(offerId);

    if (selectEl) {
      var alreadySelected =
        String((getState(root) && getState(root).selectedOfferId) || '') === String(offerId);
      selectEl.textContent = alreadySelected ? 'Selected' : 'Select this diamond';
      selectEl.disabled = alreadySelected;
    }

    // Same pattern as Book Appointment: native dialog handles backdrop + scroll lock.
    if (typeof modal.showModal === 'function') {
      if (!modal.open) modal.showModal();
    } else {
      modal.setAttribute('open', '');
    }

    var dialog = modal.querySelector('[data-pdo-detail-dialog]');
    if (dialog) {
      dialog.scrollTop = 0;
      dialog.focus();
    }
  }

  function updateExpandToggle(root) {
    var state = getState(root);
    var list = qs(root, '[data-pdo-list]');
    var toggle = qs(root, '[data-pdo-expand]');
    if (!list || !toggle || !state) return;

    var displayLimit = getDisplayLimit(root);
    var total = state.items.length;
    var needsToggle = total > displayLimit;
    var showAll = !!state.expanded;

    list.querySelectorAll('.product-diamond-options__item').forEach(function (item, index) {
      var hidden = !showAll && index >= displayLimit;
      item.hidden = hidden;
      item.classList.toggle('is-collapsed', hidden);
    });

    toggle.hidden = !needsToggle;
    toggle.textContent = showAll ? 'See less' : 'See more';
    toggle.setAttribute('aria-expanded', showAll ? 'true' : 'false');
    root.classList.toggle('is-expanded', showAll);
  }

  function renderCards(root, items) {
    var list = qs(root, '[data-pdo-list]');
    if (!list) return;

    if (!items.length) {
      list.hidden = true;
      list.innerHTML = '';
      root.classList.remove('is-expanded');
      var toggleEmpty = qs(root, '[data-pdo-expand]');
      if (toggleEmpty) toggleEmpty.hidden = true;
      return;
    }

    list.hidden = false;
    list.innerHTML = items
      .map(function (item) {
        var title = formatDiamondTitle(item);
        var specs = formatDiamondSpecs(item);
        var media = getCardMediaUrl(item);
        var mediaHtml = media.url
          ? '<img src="' +
            escapeHtml(media.url) +
            '" alt="' +
            escapeHtml(title) +
            '" loading="lazy" width="240" height="240"' +
            (media.isSample ? ' class="is-sample"' : '') +
            ' data-pdo-image data-shape="' +
            escapeHtml(item.shape || '') +
            '">'
          : '<span class="product-diamond-options__media-fallback">' +
            escapeHtml(formatShapeLabel(item.shape).slice(0, 3)) +
            '</span>';

        return (
          '<li class="product-diamond-options__item">' +
          '<button type="button" class="product-diamond-options__card" data-pdo-card data-offer-id="' +
          escapeHtml(item.offerId) +
          '" aria-pressed="false">' +
          '<span class="product-diamond-options__media">' +
          '<span class="product-diamond-options__check" aria-hidden="true"></span>' +
          mediaHtml +
          '<span class="product-diamond-options__sample-badge"' +
          (media.isSample ? '' : ' hidden') +
          '>Sample</span>' +
          '</span>' +
          '<span class="product-diamond-options__info">' +
          '<span class="product-diamond-options__title">' +
          escapeHtml(title) +
          '</span>' +
          (specs
            ? '<span class="product-diamond-options__specs">' + escapeHtml(specs) + '</span>'
            : '') +
          '</span>' +
          '</button>' +
          '<button type="button" class="product-diamond-options__view" data-pdo-view-details data-offer-id="' +
          escapeHtml(item.offerId) +
          '">View details</button>' +
          '</li>'
        );
      })
      .join('');

    attachCardImageFallbacks(root);
    updateExpandToggle(root);
  }

  function attachCardImageFallbacks(root) {
    root.querySelectorAll('[data-pdo-image]').forEach(function (imageEl) {
      imageEl.onerror = function () {
        imageEl.onerror = null;
        var shape = imageEl.getAttribute('data-shape') || '';
        var sampleUrl = getSampleDiamondImageUrl(shape);
        var card = imageEl.closest('[data-pdo-card]');
        var badge = card && card.querySelector('.product-diamond-options__sample-badge');

        if (sampleUrl && imageEl.src !== sampleUrl) {
          imageEl.src = sampleUrl;
          imageEl.classList.add('is-sample');
          if (badge) badge.hidden = false;
          imageEl.onerror = function () {
            imageEl.onerror = null;
            imageEl.replaceWith(
              (function () {
                var fallback = document.createElement('span');
                fallback.className = 'product-diamond-options__media-fallback';
                fallback.textContent = formatShapeLabel(shape).slice(0, 3);
                return fallback;
              })()
            );
            if (badge) badge.hidden = true;
          };
          return;
        }

        imageEl.replaceWith(
          (function () {
            var fallback = document.createElement('span');
            fallback.className = 'product-diamond-options__media-fallback';
            fallback.textContent = formatShapeLabel(shape).slice(0, 3);
            return fallback;
          })()
        );
        if (badge) badge.hidden = true;
      };
    });
  }

  function filterByTier(root, items, tier) {
    var colors = allowedColors(root);
    var clarities = allowedClarities(root);

    return (items || []).filter(function (item) {
      var dollars = diamondRetailDollars(item);
      var carats = diamondCarats(item);
      var color = String(item.color || '').trim().toUpperCase();
      var clarity = String(item.clarity || '').trim().toUpperCase();

      if (!isFinite(dollars) || !isFinite(carats)) return false;
      if (carats < tier.caratMin || carats > tier.caratMax) return false;
      if (dollars < tier.priceMin || dollars > tier.priceMax) return false;
      if (colors.length && colors.indexOf(color) === -1) return false;
      if (clarities.length && clarities.indexOf(clarity) === -1) return false;
      return true;
    });
  }

  function loadDiamonds(root) {
    var state = getState(root);
    if (!state) return Promise.resolve();

    var carat = readSelectedCarat(root);
    state.carat = carat;
    state.ringPriceCents = readRingPriceCents(root, carat);

    var caratLabel = qs(root, '[data-pdo-carat-label]');
    if (caratLabel) caratLabel.textContent = formatCaratChip(carat);

    var tier = getCaratTier(carat);
    var requestId = ++state.requestId;
    setStatus(root, 'Loading diamond options…', false);
    var listEl = qs(root, '[data-pdo-list]');
    if (listEl) listEl.hidden = true;

    return fetch(buildProxyUrl(root, tier), {
      headers: { Accept: 'application/json' },
    })
      .then(function (res) {
        return res.text().then(function (text) {
          var trimmed = (text || '').trim();
          if (!trimmed || trimmed.charAt(0) === '<') {
            throw new Error('Diamond service is unavailable. Please try again shortly.');
          }
          var data = JSON.parse(trimmed);
          if (!res.ok || data.error) {
            throw new Error(data.error || 'Unable to load diamonds.');
          }
          return data;
        });
      })
      .then(function (data) {
        if (requestId !== state.requestId) return;
        var rawItems = Array.isArray(data.items) ? data.items : [];
        var items = filterByTier(root, rawItems, tier);
        state.items = items;
        state.expanded = false;
        root.classList.remove('is-expanded');

        if (!items.length) {
          state.selectedOfferId = '';
          persistSelection(root, null);
          renderCards(root, []);
          setStatus(
            root,
            'Please contact our team to find the perfect diamond options.',
            false
          );
          var hintEmpty = qs(root, '[data-pdo-hint]');
          if (hintEmpty) {
            hintEmpty.textContent =
              'Optional - select a diamond to include with your ring (included in the ring price).';
          }
          return;
        }

        setStatus(root, '', false);
        renderCards(root, items);

        var preferred = state.selectedOfferId;
        var stillThere = items.some(function (item) {
          return String(item.offerId) === String(preferred);
        });
        if (stillThere) {
          selectDiamond(root, preferred, { force: true });
        } else {
          clearDiamondSelection(root);
        }
      })
      .catch(function (err) {
        if (requestId !== state.requestId) return;
        state.items = [];
        state.selectedOfferId = '';
        state.expanded = false;
        root.classList.remove('is-expanded');
        persistSelection(root, null);
        renderCards(root, []);
        var message = (err && err.message) || 'Unable to load diamonds.';
        if (/failed to fetch/i.test(message)) {
          message = isDesignMode()
            ? 'Diamond options load in storefront preview. Use Preview (top right) to test live diamonds.'
            : 'Unable to reach the diamond service. Please refresh and try again.';
        }
        setStatus(root, message, true);
        var hint = qs(root, '[data-pdo-hint]');
        if (hint) {
          hint.textContent =
            'Optional - select a diamond to include with your ring (included in the ring price).';
        }
      });
  }

  function setActiveDiamondType(root, type) {
    var nextType = type === 'natural' ? 'natural' : 'labgrown';
    root.setAttribute('data-diamond-type', nextType);

    root.querySelectorAll('[data-pdo-type-tab]').forEach(function (tab) {
      var active = tab.getAttribute('data-diamond-type') === nextType;
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
    });
  }

  function bindRoot(root) {
    if (!root || root.dataset.pdoBound === 'true') return;
    root.dataset.pdoBound = 'true';
    loadVariantPrices(root);

    root.addEventListener('click', function (event) {
      var typeTab = event.target.closest('[data-pdo-type-tab]');
      if (typeTab && root.contains(typeTab)) {
        var nextType = typeTab.getAttribute('data-diamond-type');
        if (!nextType || nextType === root.getAttribute('data-diamond-type')) return;
        setActiveDiamondType(root, nextType);
        clearDiamondSelection(root);
        loadDiamonds(root);
        return;
      }

      var expandBtn = event.target.closest('[data-pdo-expand]');
      if (expandBtn && root.contains(expandBtn)) {
        var expandState = getState(root);
        if (!expandState) return;
        expandState.expanded = !expandState.expanded;
        updateExpandToggle(root);
        return;
      }

      var viewBtn = event.target.closest('[data-pdo-view-details]');
      if (viewBtn && root.contains(viewBtn)) {
        event.preventDefault();
        event.stopPropagation();
        openDetailModal(root, viewBtn.getAttribute('data-offer-id'));
        return;
      }

      var card = event.target.closest('[data-pdo-card]');
      if (!card || !root.contains(card)) return;
      selectDiamond(root, card.getAttribute('data-offer-id'));
    });

    var modal = ensureDetailModalOnBody(root);
    if (modal && modal.dataset.pdoBound !== 'true') {
      modal.dataset.pdoBound = 'true';

      modal.addEventListener('click', function (event) {
        if (event.target.closest('[data-pdo-detail-close]')) {
          closeDetailModal(root);
          return;
        }

        // Click outside panel closes — same as appointment modal.
        var panel = modal.querySelector('.pdo-detail-modal__panel');
        if (panel && !panel.contains(event.target)) {
          closeDetailModal(root);
          return;
        }

        var thumb = event.target.closest('[data-pdo-thumb-type]');
        if (thumb && modal.contains(thumb)) {
          var mediaEl = modal.querySelector('[data-pdo-detail-media]');
          var sampleEl = modal.querySelector('[data-pdo-detail-sample]');
          var type = thumb.getAttribute('data-pdo-thumb-type');
          var url = thumb.getAttribute('data-pdo-thumb-url') || '';
          var isSample = thumb.getAttribute('data-pdo-thumb-sample') === 'true';
          modal.querySelectorAll('[data-pdo-thumb-type]').forEach(function (el) {
            el.classList.toggle('is-active', el === thumb);
          });
          setDetailMedia(mediaEl, {
            type: type,
            url: url,
            title: 'Diamond preview',
            isSample: isSample,
          });
          if (sampleEl) sampleEl.hidden = !(type === 'image' && isSample);
          return;
        }

        var selectBtn = event.target.closest('[data-pdo-detail-select]');
        if (selectBtn && modal.contains(selectBtn)) {
          var offerId = modal._pdoActiveOfferId;
          if (!offerId) return;
          selectDiamond(root, offerId, { force: true });
          closeDetailModal(root);
        }
      });

      modal.addEventListener('close', function () {
        modal._pdoActiveOfferId = '';
      });
    }
    var productInfo = root.closest('product-info') || document.querySelector('product-info');
    if (productInfo) {
      productInfo.addEventListener('change', function (event) {
        var target = event.target;
        if (!target) return;
        if (
          target.matches('input[type="radio"]') ||
          target.matches('select') ||
          target.closest('.product-form__input')
        ) {
          clearTimeout(root._pdoReloadTimer);
          root._pdoReloadTimer = setTimeout(function () {
            loadDiamonds(root);
          }, 120);
        }
      });
    }

    if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        var state = getState(root);
        if (state && event && event.data && event.data.variant && event.data.variant.price != null) {
          state.ringPriceCents = Number(event.data.variant.price) || state.ringPriceCents;
        }
        clearTimeout(root._pdoReloadTimer);
        root._pdoReloadTimer = setTimeout(function () {
          loadDiamonds(root);
        }, 80);
      });
    }

    if (!root._pdoResizeBound) {
      root._pdoResizeBound = true;
      var resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          updateExpandToggle(root);
        }, 120);
      });
    }

    // Never restore a previous auto-selection on first load.
    clearDiamondSelection(root);
    loadDiamonds(root);
  }

  /**
   * Returns diamond details to attach as line-item properties on the ring.
   * Does not create or add a separately priced diamond product.
   */
  function prepareSelectedDiamondForCart() {
    var root = getRoot();
    if (!root) return Promise.resolve(null);

    var diamond = getSelectedDiamond(root);
    if (!diamond) {
      if (root.getAttribute('data-require-selection') === 'true') {
        return Promise.reject(new Error('Please select a diamond before adding to cart.'));
      }
      return Promise.resolve(null);
    }

    return Promise.resolve({
      properties: buildDiamondLineProperties(diamond),
      includedInPrice: true,
    });
  }

  window.ProductDiamondOptions = {
    prepareSelectedDiamondForCart: prepareSelectedDiamondForCart,
    reload: function () {
      var root = getRoot();
      if (root) loadDiamonds(root);
    },
  };

  function boot() {
    document.querySelectorAll('[data-product-diamond-options]').forEach(bindRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root =
      event.target && event.target.querySelector
        ? event.target.querySelector('[data-product-diamond-options]')
        : null;
    if (root) {
      root.dataset.pdoBound = '';
      bindRoot(root);
    }
  });
})();
